import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { SPAConfiguration } from '@mobi/rwc-utils-ng-jslib';

import { OLD_PROTEKTA_B2C_DOMAINS, PROTEKTA_URL_CONST, URL_CONST } from './common.constant';
import { WINDOW } from './core/provide-oiv-core.provider';

export { WINDOW };

@Injectable({ providedIn: 'root' })
export class RouteHelper {
    #window = inject(WINDOW);
    getRoutePathOnProdStage(language: string) {
        const RWC_CONFIG: SPAConfiguration = (this.#window.document.defaultView as Window).MOBI_RWC_CONFIG;
        if (RWC_CONFIG.stage === 'prod') {
            let currentPath = this.#window.location.pathname;
            const currentHostname = this.#window.location.hostname;
            const defaultDomain = currentHostname;

            const isOldProtektaDomain = OLD_PROTEKTA_B2C_DOMAINS.includes(currentHostname);
            const isProtektaDomain = isOldProtektaDomain || PROTEKTA_URL_CONST.some(u => u.domain === currentHostname);
            const urlConst = isProtektaDomain ? PROTEKTA_URL_CONST : URL_CONST;

            // Old Protekta domain uses path-based language (/de/avb/...) — strip the prefix for new domain
            if (isOldProtektaDomain) {
                currentPath = currentPath.replace(/^\/(de|fr|it)\//, '/');
            }

            let domainName;
            switch (language) {
                case 'de':
                    domainName = urlConst.find(url => url.language === 'de')?.domain || defaultDomain;
                    break;
                case 'it':
                    domainName = urlConst.find(url => url.language === 'it')?.domain || defaultDomain;
                    break;
                case 'fr':
                    domainName = urlConst.find(url => url.language === 'fr')?.domain || defaultDomain;
                    break;
                default:
                    domainName = urlConst.find(url => url.language === 'de')?.domain || defaultDomain;
            }
            return `${domainName}${currentPath}`;
        }
        return '';
    }

    removeFirstPath(path: string): string {
        const paths = path.substring(1).split('/');
        paths.shift();
        return '/' + paths.join('/');
    }

    getHomePageURL(router: Router, source: string, isApprovalMode: boolean): string {
        return `${this.getBaseUrl(router, source, isApprovalMode)}/homepage`;
    }

    getBaseUrl(router: Router, source: string, isApprovalMode: boolean): string {
        const urlSegments = router.url.split('/');
        const validLanguageCodes = ['de', 'fr', 'it'];

        if (source === 'B2C') {
            // For B2C, check if there's a language parameter in the URL by examining the second segment
            // Protekta B2C has :language route parameter: /de/avb/urlName
            // Mobiliar B2C doesn't: /avb/urlName
            const secondSegment = urlSegments[1];
            if (validLanguageCodes.includes(secondSegment)) {
                // Language parameter exists, return 4 segments: /de/avb/urlName
                return `${urlSegments.slice(0, 4).join('/')}`;
            }
            // No language parameter, return 3 segments: /avb/urlName
            return `${urlSegments.slice(0, 3).join('/')}`;
        } else {
            // For approval mode, the base URL need to add the approval path
            if (isApprovalMode) {
                return `${urlSegments.slice(0, 5).join('/')}`;
            }
            return `${urlSegments.slice(0, 4).join('/')}`;
        }
    }

    isAvbPage(url: string): boolean {
        if (url) {
            return !url.includes('/not-found') && !url.includes('/not-available') && !url.includes('/no-permission');
        }
        return false;
    }
}
